export default __webpack_public_path__ + "static/media/qr.9c64ffaf.svg";